import { isProduction, shouldReportToSentry } from "@/utils/env";

export function logMissingSentryDsn(isDev: boolean): void {
  if (isDev) {
    console.warn(
      "⚠️ Sentry DSN not configured. Error tracking will be disabled. (Optional: Set VITE_SENTRY_DSN to enable)"
    );
  }
}

/**
 * Log Sentry Init Debug Preview.
 */
export function logSentryInitDebugPreview(dsn: string, isDev: boolean): void {
  if (!isDev) {
    return;
  }

  console.warn("🔍 Sentry Init Check:", {
    hasDsn: Boolean(dsn),
    dsnLength: dsn.length,
    dsnPreview: `${dsn.substring(0, 30)}...`,
    isProd: isProduction(),
    envMode: import.meta.env.MODE,
  });
}

export function logSentryInitSuccess(dsn: string, isDev: boolean): void {
  if (!isDev) {
    return;
  }

  console.warn("✅ Sentry initialized successfully", {
    dsn: `${dsn.substring(0, 30)}...`,
    environment: shouldReportToSentry() ? "production" : "development",
    tracesSampleRate: shouldReportToSentry() ? 0.1 : 1.0,
  });
}

/**
 * Redact Token Query From Url.
 */
export function redactTokenQueryFromUrl(url: string): string {
  const queryIndex = url.indexOf("?");
  if (queryIndex === -1) {
    return url;
  }

  const base = url.slice(0, queryIndex);
  const query = url.slice(queryIndex + 1);
  const parts = query.split("&");
  const tokenIndex = parts.findIndex((part) => part.toLowerCase().startsWith("token="));
  if (tokenIndex === -1) {
    return url;
  }

  const afterToken = parts.slice(tokenIndex + 1);
  const suffix = afterToken.length > 0 ? `&${afterToken.join("&")}` : "";
  return `${base}?token=[REDACTED]${suffix}`;
}
